class WishlistCustomer extends HTMLElement {
  constructor() {
    super();
  } 

  connectedCallback() { 
    this.listId = ''
    this.enable = window.__VPV?.wishlist?.enabled || false;
    this.active = window.__VPV?.wishlist?.ids?.includes(this.productId) || false;
    this.productId = Number(this.dataset.productId) || null;
    this.variantId = Number(this.dataset.variantId) || null;
    this.productUrl = this.dataset.productUrl;

    this.productTitle = this.dataset.productTitle;
    this.productImage = this.dataset.productImage;

    this.render();
    this.updateRender();

    // Observe attribute changes to update variantId when it changes
    this.attributeObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-variant-id') {
          const newVariantId = Number(this.dataset.variantId) || null;
          if (newVariantId !== this.variantId) {
            this.variantId = newVariantId;
            // Update active state based on new variant if needed
            this.updateRender();
          }
        }
      });
    });

    this.attributeObserver.observe(this, {
      attributes: true,
      attributeFilter: ['data-variant-id']
    });

    this.addEventListener('click', () => this.handleClick());
    window.addEventListener('wishlist-ready', (event) => {
      this.enable = true;
      this.listId = window.__VPV?.wishlist?.listId || '';
      this.updateRender();
    });
    window.addEventListener('wishlist-update', () => {
      this.active = window.__VPV?.wishlist?.ids?.includes(this.productId) || false;
      this.updateRender();
    });

    // Listen for variant changes on product page
    this.variantChangeHandler = (event) => {
      // Only update if this wishlist element is on a product page (within .product-info)
      const isOnProductPage = this.closest('.product-info') !== null;
      if (isOnProductPage && event.detail?.variant?.id) {
        const newVariantId = Number(event.detail.variant.id);
        if (newVariantId && newVariantId !== this.variantId) {
          this.setAttribute('data-variant-id', newVariantId);
          // The MutationObserver will pick this up and update this.variantId
        }
      }
    };
    document.addEventListener('variant:change', this.variantChangeHandler);
  }

  disconnectedCallback() {
    // Clean up the observer when the element is removed
    if (this.attributeObserver) {
      this.attributeObserver.disconnect();
    }
    // Clean up the variant change event listener
    if (this.variantChangeHandler) {
      document.removeEventListener('variant:change', this.variantChangeHandler);
    }
  }

  handleClick() {
    if (window._swat) {
      this.listId = window.__VPV?.wishlist?.listId || '';
      console.log('🚀 -> WishlistCustomer -> handleClick -> this.listId:', this.listId)
      const product = {
        epi: this.variantId, // variant ID
        empi: this.productId, // Product ID
        du: this.productUrl, // Product URL w/ domain
      };
      console.log('🚀 -> WishlistCustomer -> handleClick -> product:', product)
      const prevState = this.active;
      this.active
        ? this.removeProductFromList(product)
        : this.addProductToList(product);

      this.updateRender();

      const event = new CustomEvent('wishlist-update');
      window.dispatchEvent(event);
    }
  }

  generateModal(prevState) {
    console.log('🚀 -> WishlistCustomer -> generateModal -> generateModal:', prevState)
    // if (prevState) {
    //   // Modal que diga fue removido correctamente
    // } else {
    //   // Modal que diga fue agregado correctamente
    // }
    const message = 'has been added to your wishlist successfully.';


    const modalEvent = new CustomEvent('open-wishlist-modal', {
      detail: {
        title: this.productTitle,
        image: this.productImage || 'https://via.placeholder.com/150',
        message: message,
      }
    });
    window.dispatchEvent(modalEvent);
  }

  addProductToList(product) {
    window._swat.addToList(this.listId, product, this.onSuccess.bind(this, true), this.onError.bind(this));
    window.__VPV?.wishlist?.ids?.push(this.productId);
    this.generateModal(false);
  }

  removeProductFromList(product) {
    console.log('removeProductFromList', product);
    window._swat.deleteFromList(this.listId, product, this.onSuccess.bind(this, false), this.onError.bind(this));
    const index = window.__VPV?.wishlist?.ids?.indexOf(this.productId);
    if (index > -1) {
      window.__VPV.wishlist.ids.splice(index, 1);
    }
  }

  onSuccess(event, isAdded) {
    console.log('🚀 -> WishlistCustomer -> onSuccess -> Product updated:', this.productId);
    console.log(event)
    this.active = isAdded;
    this.updateRender();
  }

  onError(event) {
    console.error('🚀 -> WishlistCustomer -> onError -> Error :', this.productId);
    console.error(event);
  }

  updateRender() {
    this.active = window.__VPV?.wishlist?.ids?.includes(this.productId);
    this.classList.toggle('is-active', this.active);
    this.classList.toggle('is-enabled', this.enable);
  }

  render() {
    this.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
        <path d="M9.00146 5.24023C10.6719 5.23922 12.2746 5.9017 13.4565 7.08203L13.4624 7.08789L13.4692 7.09375L14.9927 8.51758L15.3335 8.83594L15.6743 8.51855L17.2085 7.08984L17.2202 7.07812C18.1022 6.20051 19.225 5.60361 20.4458 5.36328C21.6665 5.12305 22.9309 5.25077 24.0796 5.72852C25.2285 6.20638 26.2106 7.01356 26.9009 8.04883C27.5911 9.08407 27.9591 10.3007 27.9585 11.5449V11.5459C27.9603 12.3725 27.7985 13.1915 27.4819 13.9551C27.1653 14.7187 26.7001 15.4123 26.1138 15.9951L26.1099 15.999L15.645 26.6182C15.6043 26.6595 15.5559 26.6924 15.5024 26.7148C15.4489 26.7372 15.3915 26.749 15.3335 26.749C15.2755 26.749 15.218 26.7372 15.1646 26.7148C15.1111 26.6924 15.0626 26.6595 15.022 26.6182L4.55713 15.999L4.5542 15.9961L4.33838 15.7695C3.29158 14.6147 2.7075 13.109 2.70654 11.543C2.70555 9.87251 3.36793 8.26986 4.54834 7.08789C5.72886 5.90594 7.33095 5.24132 9.00146 5.24023Z" fill="currentColor" stroke="#2B2E2F"/>
      </svg>
    `
  }
}

customElements.define('wishlist-customer', WishlistCustomer);
